import { render, staticRenderFns } from "./InfoAssess.vue?vue&type=template&id=5166ab78&scoped=true"
import script from "./InfoAssess.vue?vue&type=script&lang=js"
export * from "./InfoAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5166ab78",
  null
  
)

export default component.exports